import { Component, Input, OnInit } from '@angular/core';

import ActionTypesEnum from '@shared/enums/action-constant.enum';

import { CustomEventService } from '@shared/services/custom-event.service';

import { Router } from '@angular/router';

import { backgroundImageCreator } from '@shared/utils/object-mapper.util';

import { UntilDestroy } from '@ngneat/until-destroy';
import { DEFAULT_PAGE_SIZE } from "@shared/variables/constant-variable";

@UntilDestroy()
@Component({
  selector: 'app-developer-list-modal',
  templateUrl: './developer-list-modal.component.html'
})
export class DeveloperListModalComponent implements OnInit {

  constructor(private customEventService: CustomEventService,
              private router: Router) { }

  PAGE_SIZE = 7;
  NAME_LENGTH = 25;
  COMPANY_ROLE_LENGTH = 15;

  @Input() developers: any[];
  @Input() type?: string;
  @Input() title?: string;
  displayDevelopers: any[] = [];
  searchValue = '';
  pageIndex = 1;
  listOfFilterAddress = [
    { text: 'Active', value: true, byDefault: true  },
    { text: 'Deactive', value: false, byDefault: true }
    ];
  listOfSearchStatus = [true, false];

  protected readonly DEFAULT_PAGE_SIZE = DEFAULT_PAGE_SIZE;

  ngOnInit(): void {
    this.displayDevelopers = this.developers;
    this.displayDevelopers = this.displayDevelopers.map(backgroundImageCreator);

    if (this.displayDevelopers.some(item => item.active)) {
      this.displayDevelopers.sort((a,b) => (a.active === b.active) ? 0 : a.active ? -1 : 1);
    }
  }

  filterStatusChange(value: boolean[]): void {
    this.listOfSearchStatus = value;
    this.search();
  }

  pageIndexChange($event){
    this.pageIndex = $event;
  }

  search(): void {
    const filterFunc = (item: { fullName: string; active: boolean }) => {
      return (
        this.type === 'contributor'
          ? (this.listOfSearchStatus.length ? this.listOfSearchStatus.some(active => item.active === active) : false) && item.fullName.toLowerCase().indexOf(this.searchValue.toLowerCase()) !== -1
          : item.fullName.toLowerCase().indexOf(this.searchValue.toLowerCase()) !== -1
      );
    };
    this.displayDevelopers = this.developers.filter(filterFunc);
  }

  closeModal(): void {
    this.customEventService.announceEvent(ActionTypesEnum.CLOSE_MODAL);
  }

  cardClickHandler(item: any): void {
    if (this.type === 'developer' || this.type === 'member' && item.clickable) {
      this.router.navigate([`/scorecard/developer`, item.id]);
      this.closeModal();
    }
    if (this.type === 'assignees') {
      window.open(item, '_blank');
    }
  }

  update(item): void {
    this.customEventService.announceEvent(ActionTypesEnum.CLOSE_MODAL);
    this.customEventService.announceEvent(ActionTypesEnum.UPDATE_DEVELOPER_POPUP, item);
  }

  delete(itemId) {
    this.displayDevelopers = this.displayDevelopers.filter(developer => developer.id !== itemId);
    this.customEventService.announceEvent(ActionTypesEnum.DELETE_DEVELOPER_POPUP, itemId);
  }
}
